import { Chip, Grid } from "@mui/material";
import EditAction from "../components/edit-action/edit-action";
import DeleteAction from "../components/delete-action/delete-action";
import dayjs from 'dayjs';
import VerifyAccess from "@/common/components/verify-access/verify-access";
import { requestedMenuAll, requestedFeaturesAll } from "@/from-theme/routes/constants/menuAccess";
import { dateString } from "@/common/components/TableView/helpers/helpers";
const {accommodationTabMasterKey} = requestedMenuAll;
const {updateKey, deleteKey} = requestedFeaturesAll;

export const columns = ({ onRowEdit, onRowDelete, deleteAllowanceMasterStatus,
  isUpdateDeleteAccess }) => ([...[
  {
    header: 's-no',
    accessorKey: 'accomodationId',
    cell: (value) => {
      const accomodationId = value.row.index + 1;
     return accomodationId;
    }
  },
  {
    header: 'grade-name',
    accessorKey: 'gradeName'
  },
  {
    header: 'category',
    accessorKey: 'accomCategory'
  },
  {
    header: 'lodgingCost',
    accessorKey: 'lodgingCost'
  },
  {
    header: 'boardingCost',
    accessorKey: 'boardingCost'
  },
  {
    header: 'valid-from',
    accessorKey: 'accomValidFrom',
    cell: (cell) => {
      const value = cell.getValue();
      const formattedDate = dayjs(value).format('DD-MM-YYYY');
      return <span>{formattedDate}</span>;
    },
    meta: {
      className: 'cell-right'
    }
  },
  {
    header: 'valid-to',
    hideColumn: false,
    accessorKey: 'accomValidTo',
    cell: (cell) => {
      const value = cell.getValue();
      const formattedDate = dayjs(value).format('DD-MM-YYYY');
      return <span>{formattedDate}</span>;
    },
    meta: {
      className: 'cell-right'
    }
  },
  {
    header: 'created-at',
    hideColumn: true,
    accessorKey: 'createdAt',
    cell: ({ getValue }) => dateString(getValue()) 
  },
  {
    header: 'created-by',
    hideColumn: true,
    accessorKey: 'createdBy'
  },
  {
    header: 'updated-at',
    hideColumn: true,
    accessorKey: 'updatedAt',
    cell: ({ getValue }) => dateString(getValue()) 
  },
  {
    header: 'updated-by',
    hideColumn: true,
    accessorKey: 'updatedBy'
  },
  {
    header: 'status',
    accessorKey: 'activeStatus',
    cell: (cell) => {
      switch (cell.getValue()) {
        case '0':
          return <Chip color="error" label="In-Active" size="small" variant="light" />;
        case '1':
          return <Chip color="success" label="Active" size="small" variant="light" />;
      }
    }
  }
], ...(isUpdateDeleteAccess ? [
  {
    header: 'action',
    id: "edit",
    cell: (props) => (
      <Grid container className="table-icon-actions-2">
        <VerifyAccess requestedMenu={accommodationTabMasterKey} requestedFeature={updateKey}>
        <Grid item>
          <EditAction
            {...props}
            onRowEdit={onRowEdit}
          />
        </Grid>
        </VerifyAccess>
        <VerifyAccess requestedMenu={accommodationTabMasterKey} requestedFeature={deleteKey}>
        <Grid item>
          <DeleteAction
            {...props}
            onRowDelete={onRowDelete} deleteAllowanceMasterStatus={deleteAllowanceMasterStatus}
          />
        </Grid>
        </VerifyAccess>
      </Grid>
    ),
    meta: {
      className: 'cell-center'
    }
  }

]: [])]);

export const reportFileName = "Accommodation Master";

